import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  constructor(@Inject('environment') private environment: any) {
  }

  getConfig(key: string) {
    return this.environment[key];
  }
}